// ไฟล์: frontend/src/pages/admin/Classes.js
import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Footer from '../../components/Footer';
import api from '../../services/api';
import Swal from 'sweetalert2';

function AdminClasses() {
  const [classes, setClasses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    class_name: '',
    grade: '',
    room_number: '',
    academic_year: '',
    teacher_id: ''
  });
  const [formMode, setFormMode] = useState('add'); // 'add' หรือ 'edit'
  
  useEffect(() => {
    fetchClasses();
    fetchTeachers();
  }, []);
  
  const fetchClasses = async () => {
    try {
      setIsLoading(true);
      const response = await api.class.getAllClasses();
      setClasses(response.data.data || []);
    } catch (error) {
      console.error('Error fetching classes:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลชั้นเรียนได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const fetchTeachers = async () => {
    try {
      const response = await api.user.getAllTeachers();
      setTeachers(response.data.data || []);
    } catch (error) {
      console.error('Error fetching teachers:', error);
    }
  };
  
  const handleShowAddModal = () => {
    setFormData({
      id: '',
      class_name: '',
      grade: '',
      room_number: '',
      academic_year: new Date().getFullYear().toString(),
      teacher_id: ''
    });
    setFormMode('add');
    setShowModal(true);
  };
  
  const handleShowEditModal = (classItem) => {
    setFormData({
      id: classItem.id,
      class_name: classItem.class_name,
      grade: classItem.grade,
      room_number: classItem.room_number,
      academic_year: classItem.academic_year,
      teacher_id: classItem.teacher_id || ''
    });
    setFormMode('edit');
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    setShowModal(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ตรวจสอบข้อมูลที่จำเป็น
    if (!formData.class_name || !formData.grade || !formData.room_number || !formData.academic_year) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        text: 'กรุณากรอกชื่อชั้นเรียน ระดับชั้น ห้องเรียน และปีการศึกษา',
        confirmButtonColor: '#ff6b01'
      });
      return;
    }
    
    try {
      setIsLoading(true);
      
      let response;
      if (formMode === 'add') {
        // เพิ่มชั้นเรียนใหม่
        response = await api.class.createClass(formData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'เพิ่มชั้นเรียนเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      } else {
        // แก้ไขข้อมูลชั้นเรียน
        response = await api.class.updateClass(formData.id, formData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'แก้ไขข้อมูลชั้นเรียนเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      }
      
      // ปิด Modal และโหลดข้อมูลใหม่
      setShowModal(false);
      fetchClasses();
    } catch (error) {
      console.error('Error saving class:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถบันทึกข้อมูลชั้นเรียนได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'ยืนยันการลบ',
      text: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลชั้นเรียนนี้?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff6b01',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.class.deleteClass(id);
          Swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ',
            text: 'ลบข้อมูลชั้นเรียนเรียบร้อยแล้ว',
            confirmButtonColor: '#ff6b01'
          });
          fetchClasses();
        } catch (error) {
          console.error('Error deleting class:', error);
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถลบข้อมูลชั้นเรียนได้',
            confirmButtonColor: '#ff6b01'
          });
        }
      }
    });
  };
  
  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">จัดการข้อมูลชั้นเรียน</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/admin/dashboard">หน้าหลัก</a>
                  </li>
                  <li className="breadcrumb-item active">ชั้นเรียน</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        
        <section className="content">
          <div className="container-fluid">
            <div className="card card-orange">
              <div className="card-header">
                <h3 className="card-title">ข้อมูลชั้นเรียนทั้งหมด</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={handleShowAddModal}
                  >
                    <i className="fas fa-plus"></i> เพิ่มชั้นเรียน
                  </button>
                </div>
              </div>
              <div className="card-body">
                {isLoading ? (
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>ชั้นเรียน</th>
                          <th>ระดับชั้น</th>
                          <th>ห้อง</th>
                          <th>ปีการศึกษา</th>
                          <th>ครูประจำชั้น</th>
                          <th>จำนวนนักเรียน</th>
                          <th>ตัวเลือก</th>
                        </tr>
                      </thead>
                      <tbody>
                        {classes.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center">
                              ไม่พบข้อมูลชั้นเรียน
                            </td>
                          </tr>
                        ) : (
                          classes.map((classItem) => (
                            <tr key={classItem.id}>
                              <td>{classItem.class_name}</td>
                              <td>{classItem.grade}</td>
                              <td>{classItem.room_number}</td>
                              <td>{classItem.academic_year}</td>
                              <td>{classItem.teacher_name || '-'}</td>
                              <td>
                                <span className="badge bg-primary">
                                  {classItem.student_count || 0} คน
                                </span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-info btn-sm mr-1"
                                  onClick={() => handleShowEditModal(classItem)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(classItem.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      
      {/* Modal เพิ่ม/แก้ไขข้อมูลชั้นเรียน */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', paddingRight: '15px' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-orange">
                <h5 className="modal-title">
                  {formMode === 'add' ? 'เพิ่มชั้นเรียนใหม่' : 'แก้ไขข้อมูลชั้นเรียน'}
                </h5>
                <button type="button" className="close" onClick={handleCloseModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="form-group">
                    <label>ชื่อชั้นเรียน <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="class_name"
                      value={formData.class_name}
                      onChange={handleInputChange}
                      placeholder="เช่น ป.1/1, ม.3/2"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>ระดับชั้น <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="grade"
                      value={formData.grade}
                      onChange={handleInputChange}
                      placeholder="เช่น ประถมศึกษาปีที่ 1, มัธยมศึกษาปีที่ 3"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>ห้อง <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="room_number"
                      value={formData.room_number}
                      onChange={handleInputChange}
                      placeholder="เช่น 101, 302"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>ปีการศึกษา <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="academic_year"
                      value={formData.academic_year}
                      onChange={handleInputChange}
                      placeholder="เช่น 2565"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>ครูประจำชั้น</label>
                    <select
                      className="form-control"
                      name="teacher_id"
                      value={formData.teacher_id}
                      onChange={handleInputChange}
                    >
                      <option value="">-- เลือกครูประจำชั้น --</option>
                      {teachers.map((teacher) => (
                        <option key={teacher.id} value={teacher.id}>
                          {teacher.first_name} {teacher.last_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    ยกเลิก
                  </button>
                  <button type="submit" className="btn btn-orange" disabled={isLoading}>
                    {isLoading ? (
                      <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</>
                    ) : (
                      <>บันทึก</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          {/* พื้นหลังทึบ */}
          <div className="modal- fade show"></div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}

export default AdminClasses;